import { slicedToArray as _slicedToArray, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useCallback } from 'react';
import { i18n } from '../../i18n/translate.js';
import { FileUpload } from '../Uploader/FileUpload.js';
import { s3MediaUploader, externalS3MediaUploader } from '../Uploader/S3Uploader.js';
import { RichTextEditor as RichTextEditor$1 } from '../../core/components/RichTextEditor/component.js';
import { Modal } from '../../core/components/Modal/component.js';
var RichTextEditor = function RichTextEditor(_ref) {
  var initialValue = _ref.initialValue,
    onChange = _ref.onChange,
    _ref$dataType = _ref.dataType,
    dataType = _ref$dataType === void 0 ? 'html' : _ref$dataType,
    _ref$shouldSanitize = _ref.shouldSanitize,
    shouldSanitize = _ref$shouldSanitize === void 0 ? false : _ref$shouldSanitize,
    apiUrl = _ref.apiUrl,
    jwt = _ref.jwt,
    allowCodeToggle = _ref.allowCodeToggle,
    formElementName = _ref.formElementName,
    uploader = _ref.uploader;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    imageUploaderOpen = _useState2[0],
    setImageUploaderOpen = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    imagePath = _useState4[0],
    setImagePath = _useState4[1];
  var imageUploadSuccess = useCallback(function (e) {
    if ((e === null || e === void 0 ? void 0 : e.fileLocation) !== imagePath) {
      setImagePath(e === null || e === void 0 ? void 0 : e.fileLocation);
    } else {
      setImagePath(null);
    }
    setImageUploaderOpen(false);
  }, [imagePath]);
  var imageUploadError = useCallback(function (e) {
    setImagePath(null);
    setImageUploaderOpen(false);
  }, []);
  var uploadAndInsertImage = useCallback(function (event) {
    event.preventDefault();
    setImageUploaderOpen(true);
  }, []);
  var custImageBtn = [{
    isActive: false,
    isDisabled: false,
    icon: 'image',
    handlerCallback: uploadAndInsertImage
  }];
  var uploadProps = {
    // send in an upload handler. Was done to accommodate Next with RichNextEditor but can be used from other components
    uploader: uploader || s3MediaUploader
  };
  if (apiUrl && jwt) {
    // TODO: We will need an endpoint that supports act: public-read in order for this to work--currently, it's private-read.
    uploadProps = {
      uploader: externalS3MediaUploader,
      url: apiUrl,
      authToken: jwt
    };
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RichTextEditor$1, {
    customButtons: custImageBtn,
    imagePath: imagePath,
    onChange: onChange,
    initialValue: initialValue,
    dataType: dataType,
    shouldSanitize: shouldSanitize,
    allowCodeToggle: allowCodeToggle,
    formElementName: formElementName
  }), /*#__PURE__*/React.createElement(Modal, {
    id: "course-settings-modal",
    isOpen: imageUploaderOpen,
    modalType: "modal",
    header: i18n.t('Insert Image'),
    showCloseButton: true,
    onClose: function onClose() {
      return setImageUploaderOpen(false);
    }
  }, /*#__PURE__*/React.createElement(FileUpload, _extends({
    files: []
  }, uploadProps, {
    header: false,
    name: "filename",
    parameters: {
      acl: 'public-read'
    },
    description: {
      textArray: ['File format: jpg, gif, png']
    },
    accept: ['jpg', 'gif', 'png', 'jpeg'],
    icon: {
      className: 'images',
      fileClassName: 'file',
      noFileClassName: 'file-slash'
    },
    input: {
      name: 'upload'
    },
    button: {
      text: 'Choose an image',
      className: 'btn btn-secondary'
    },
    actions: {
      success: imageUploadSuccess,
      failure: imageUploadError
    }
  }))));
};
export { RichTextEditor };